import { render, staticRenderFns } from "./SellsyAIMenu.vue?vue&type=template&id=6c2edf33&"
import script from "./SellsyAIMenu.vue?vue&type=script&lang=js&"
export * from "./SellsyAIMenu.vue?vue&type=script&lang=js&"
import style0 from "./SellsyAIMenu.vue?vue&type=style&index=0&id=6c2edf33&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports